module.exports = __webpack_public_path__ + "static/img/default-discount-tag.834d1be8.png";